export const CALLPAGE_VALID_ISO_CODES = {
  es: 'es',
  it: 'it',
  fr: 'fr',
  de: 'de',
  pt: 'pt',
  us: 'us',
  ca: 'ca',
  mx: 'mx',
  br: 'br',
  gb: 'gb',
  ie: 'ie',
  co: 'co',
}

export const VALID_ISO_CODES = {
  ...CALLPAGE_VALID_ISO_CODES,
  ar: 'ar',
  cl: 'cl',
}

export type IsoCode = keyof typeof VALID_ISO_CODES

export type PhoneNumber = {
  label: string
  phone: string
}

type localePhones = {
  phoneNumber: PhoneNumber
  timeZone: string
}

type GlobalPhones = {
  [key in IsoCode]: localePhones
}

const GLOBAL_PHONES: GlobalPhones = {
  es: {
    phoneNumber: {
      label: '+34 930 46 53 10',
      phone: '+34930465310',
    },
    timeZone: '(CET)',
  },
  it: {
    phoneNumber: {
      label: '+39 02 8295 0237',
      phone: '+390282950237',
    },
    timeZone: '(CET)',
  },
  fr: {
    phoneNumber: {
      label: '+33 1 76 40 25 26',
      phone: '+33176402526',
    },
    timeZone: '(CET)',
  },
  de: {
    phoneNumber: {
      label: '+49 89 120 80652',
      phone: '+498912080652',
    },
    timeZone: '(CET)',
  },
  gb: {
    phoneNumber: {
      label: '+44 20 3318 5548',
      phone: '+442033185548',
    },
    timeZone: '(GMT)',
  },
  ie: {
    phoneNumber: {
      label: '+44 20 3318 5548',
      phone: '+442033185548',
    },
    timeZone: '(GMT)',
  },
  pt: {
    phoneNumber: {
      label: '+351 21 145 2144',
      phone: '+351211452144',
    },
    timeZone: '(WET)',
  },
  us: {
    phoneNumber: {
      label: '+1 786 377 4179',
      phone: '+17863774179',
    },
    timeZone: '(CT, UTC-6)',
  },
  ca: {
    phoneNumber: {
      label: '+1 786 377 4179',
      phone: '+17863774179',
    },
    timeZone: '(CT, UTC-6)',
  },
  mx: {
    phoneNumber: {
      label: '+55 3687 7148',
      phone: '+5536877148',
    },
    timeZone: '(CT, UTC-6)',
  },
  br: {
    phoneNumber: {
      label: '+55 (11) 91802-0851',
      phone: '+55 (11) 91802-0851',
    },
    timeZone: '(BRT)',
  },
  co: {
    phoneNumber: {
      label: '+55 3687 7148',
      phone: '+5536877148',
    },
    timeZone: '(COT)',
  },
  ar: {
    phoneNumber: {
      label: '+55 3687 7148',
      phone: '+5536877148',
    },
    timeZone: '(ART)',
  },
  cl: {
    phoneNumber: {
      label: '+55 3687 7148',
      phone: '+5536877148',
    },
    timeZone: '(CLT)',
  },
}

export { GLOBAL_PHONES }
